import { clear, selectDocuments } from '../redux/slices/documentSlice';
import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import Compressor from 'compressorjs';
import styles from '../styles/image-upload-box.module.css';
import Swal from 'sweetalert2';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';

/* eslint-disable @typescript-eslint/no-unused-vars */
const ImageUploadBox = ({ type, file, fetch }) => {
	const { t } = useTranslation();
	const { passport, idFront, idBack } = useAppSelector(selectDocuments);
	const dispatch = useAppDispatch();

	const [_, setSelectedImage, selectedImageRef] = useState();
	const [__, setFilename, filenameRef] = useState();

	useEffect(() => {
		if (file === 'passport') {
			setSelectedImage(passport);
		} else if (file === 'idFront') {
			setSelectedImage(idFront);
		} else {
			setSelectedImage(idBack);
		}
	}, [passport, idFront, idBack]);

	const inputRef = useRef();

	const handleClick = () => {
		inputRef?.current.click();
	};

	const compressDoc = (file) => {
		return new Promise((resolve, reject) => {
			new Compressor(file, {
				quality: 1,
				success: resolve,
				error: reject,
			});
		});
	};

	const base64converter = (file) => {
		const reader = new global.FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			const base64 = reader.result;
			dispatch(fetch(base64));
		};
	};

	const binaryFile = async (f) => {
		try {
			// const compressedFile = await compressDoc(f);
			// if (compressedFile) {
			// 	base64converter(f);
			// } else {
			// 	base64converter(f);
			// }
			base64converter(f);
		} catch (error) {
			base64converter(f);
		}
	};

	// This function will be triggered when the file field change
	const imageChange = (e) => {
		if (e.target.files && e.target.files.length > 0) {
			const input = e.target;
			// if (input.files[0].size > 500000) {
			// 	Swal.fire({
			// 		icon: 'error',
			// 		title: `${t('DocuScanPageUploadMessage1')}${t(
			// 			'DocuScanPageUploadMessage2'
			// 		)}${t('DocuScanPageUploadMessage3')} ${t(
			// 			'DocuScanPageUploadMessage4'
			// 		)} ${t('DocuScanPageUploadMessage5')}`,
			// 		text: '',
			// 	});
			// 	document.getElementById('select-image').value = '';
			// 	return;
			// }

			if (input.files && input.files.length > 0) {
				const reader = new FileReader();

				reader.onload = (event) => {
					const fileType = input.files[0].type;

					if (fileType === 'application/pdf') {
						binaryFile(input.files[0]);
						setFilename(input.files[0].name);
					} else if (fileType.startsWith('image/')) {
						const img = new Image();
						img.src = event.target.result;

						img.onload = () => {
							const canvas = document.createElement('canvas');
							const context = canvas.getContext('2d');

							// Set the desired width and height
							const maxWidth = 1200; // replace with your desired width
							const maxHeight = 1000; // replace with your desired height

							// Calculate the new dimensions while maintaining the aspect ratio
							let newWidth, newHeight;
							if (img.width > img.height) {
								newWidth = maxWidth;
								newHeight = (maxWidth / img.width) * img.height;
							} else {
								newHeight = maxHeight;
								newWidth = (maxHeight / img.height) * img.width;
							}

							// Set the canvas dimensions
							canvas.width = newWidth;
							canvas.height = newHeight;

							// Draw the image on the canvas with the new dimensions
							context.drawImage(img, 0, 0, newWidth, newHeight);

							// Get the resized data URL from the canvas
							const resizedDataURL = canvas.toDataURL('image/jpeg'); // Adjust the format as needed
							// binaryFile(resizedDataURL);
							const base64 = resizedDataURL;
							dispatch(fetch(base64));
							setFilename(e.target.files[0].name);
							// Now you can use the resizedDataURL as needed
							console.log(resizedDataURL);
						};
					}
				};

				reader.readAsDataURL(input.files[0]);
			}
		}
	};

	return (
		<>
			<div className="mt-2 theme-upload">
				<input
					ref={inputRef}
					type="file"
					accept="image/*, application/pdf"
					id="select-image"
					style={{ display: 'none' }}
					onChangeCapture={imageChange}
				/>
				<label
					htmlFor="select-image"
					style={{ minWidth: '100%' }}
					className="mb-2">
					<button
						id="btn-selectimage"
						type="button"
						style={{
							border: 'none',
							padding: '0px',
							borderRadius: '16px',
							minWidth: '100%',
							maxWidth: '100%',
						}}
						onClick={handleClick}>
						{selectedImageRef?.current?.split(';')[0]?.split('/')[1] ===
						'pdf' ? (
							<img
								src={process.env.PUBLIC_URL + '/pdf.png'}
								className={styles.image}
								alt="default picture"
							/>
						) : selectedImageRef?.current ? (
							<img
								style={{
									overflow: 'hidden',
								}}
								src={selectedImageRef?.current}
								className={`${styles.image} rounded-top-4`}
								alt="Thumb"
							/>
						) : (
							<div
								className="d-flex flex-column gap-3 justify-content-center bg-white py-4 align-items-center border rounded-4"
								style={{ borderColor: 'gray' }}>
								<img
									src={process.env.PUBLIC_URL + '/Upload_icon.svg'}
									alt="upload"
									className="mx-auto mt-4"
									height="50px"
								/>

								<strong style={{ color: 'red' }} className="fa-6 fw-light">
									{type}
								</strong>
								<div>
									<p className="m-0">
										<span style={{ color: '#03355C' }}>
											{t('DocuScanPageUploadMessage1')}
										</span>
										{t('DocuScanPageUploadMessage2')}
										<span style={{ color: '#03355C' }}>
											{t('DocuScanPageUploadMessage3')}
										</span>{' '}
										{t('DocuScanPageUploadMessage4')}
									</p>
									<p className="m-0">{t('DocuScanPageUploadMessage5')}</p>
								</div>
							</div>
						)}
					</button>
					{filenameRef?.current && (
						<div
							className="alert alert-info text-center pointer-hand m-0 p-2 rounded-top-0 theme-doc-alert"
							role="button">
							<strong>{filenameRef?.current}</strong>
						</div>
					)}
				</label>
			</div>
		</>
	);
};

export default ImageUploadBox;
